import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapper: BoxProps = {};
export const InfoExoticsContainer: CSSObject = {
  '&&': {
    mt: '0',
    px: '0',
  },
};
